type PostalCodeResultFromMasterdata = {
  CepFinal: number;
  CepInicial: number;
  IdPoliticaComercial: string;
  NomePoliticaComercial: string;
  postalCode?: string;
};

type StateType = {
  searchingPostalcode: boolean;
  postalCodeIsValid: boolean;
};
class SalesChannelSelector {
  storageName = {
    postalcode: 'SalesChannelSelectorPostalCode',
  };
  userGeoLocation = null;
  userPostalCode = null;
  userAlowSharePosition: null | boolean = null;
  $widget;
  $postalCodeForm;
  $postalCodeInput;
  $btnUseGeoLocation;
  $messageResult;
  masterdataCP: IVtexMasterdata; // faixa de ceps
  masterdataCN: IVtexMasterdata; // faixa de ceps não atendidos, log.
  state: StateType;
  lastSearchPostalCode: string;
  defaultSalesChannel = '1';
  callbacksAfterOkBeforeReload = [];

  constructor() {
    this.$widget = $('#ModalAlterarLocalizacao');
    this.$postalCodeForm = this.$widget.find('form');
    this.$postalCodeInput = this.$widget.find('#buscar-localizacao');
    this.$btnUseGeoLocation = this.$widget.find('#btn-alterar-localizacao');
    this.$messageResult = this.$widget.find('#ModalAlterarLocalizacao-result');
    this.masterdataCP = window.storeTheme.helpers.vtexMasterdata({ entity_sigla: 'CP' });
    this.masterdataCN = window.storeTheme.helpers.vtexMasterdata({ entity_sigla: 'CN' });

    this.fixSalesChannel();
    this.triggers();
  }

  async handlePostalcodeFormSubmit(event) {
    event.preventDefault();
    const code = this.$postalCodeInput.val().replace(/\D/g, '');

    if (!this.state.postalCodeIsValid) {
      this.$postalCodeInput.focus().fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
      return false;
    }

    this.lastSearchPostalCode = code;
    window.localStorage.setItem('postalcode-last-searched', this.lastSearchPostalCode);
    const data = await this.serchPostalCodeInMasterdata(this.lastSearchPostalCode);
    console.log('🥩  Result search postalcode', data);
    if (!data) {
      this.prepareEnvForNotAllowedPostalCode({
        postalCode: this.lastSearchPostalCode,
      });
      return;
    }

    await this.prepareEnvForAllowedPostalCode({
      ...data,
      postalCode: this.lastSearchPostalCode,
    });
  }

  showModal(callbacks) {
    this.$widget.modal('show');
    if (callbacks) {
      this.callbacksAfterOkBeforeReload.push(callbacks);
    }
  }

  showLoader() {
    this.$widget.addClass('loading');
  }

  hideLoader() {
    this.$widget.removeClass('loading');
  }

  formatPostalCode(code) {
    const re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;
    if (re.test(code)) {
      return code.replace(re, '$1$2-$3');
    }
    return '';
  }

  showMessageForNotAllowedPostalCode() {
    const $msg = $(this.$widget.find('#messageForNotAllowedPostalCode').text());
    $msg.find('.postal-code').html(this.formatPostalCode(this.lastSearchPostalCode));
    this.$messageResult.html($msg);
  }

  showMessageForAllowedPostalCode() {
    const $msg = $(this.$widget.find('#messageForAllowedPostalCode').text());
    this.$messageResult.html($msg);
  }

  userWasPostalCode() {
    let data;
    try {
      data = JSON.parse(window.localStorage.getItem('postalcode-data'));
    } catch (e) {
      console.error(e);
    }

    if (data?.postalCode) {
      return true;
    }

    return false;
  }

  getUserPostalCodeData() {
    let data;
    try {
      data = JSON.parse(window.localStorage.getItem('postalcode-data'));
    } catch (e) {
      console.error(e);
    }

    return data;
  }

  getUserPostalCode() {
    const data = this.getUserPostalCodeData();
    return data?.postalCode;
  }

  async prepareEnvForNotAllowedPostalCode(data) {
    window.localStorage.setItem('postalcode-allowed', '0');
    window.localStorage.setItem('postalcode-data', JSON.stringify(data));
    this.showMessageForNotAllowedPostalCode();
    await this.masterdataCN.post({ postalCode: data.postalCode, urlRequest: window.location.href });
    await this.setSalesChannel(this.defaultSalesChannel);
    await this.validateBodyClass();
    this.$widget
      .find('.close')
      .off('click.validationOfPostalcode')
      .on('click.validationOfPostalcode', () => {
        window.location.reload();
      });
  }

  async setPostalCodeOncheckout(postalcode) {
    try {
      if (postalcode) {
        await vtexjs.checkout.calculateShipping({ postalCode: postalcode, country: 'BRA' });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async prepareEnvForAllowedPostalCode(data) {
    window.localStorage.setItem('postalcode-allowed', '1');
    window.localStorage.setItem('postalcode-data', JSON.stringify(data));
    this.validateBodyClass();
    this.showMessageForAllowedPostalCode();
    this.$widget.find('.close').hide();
    this.$widget.find('.form-group-container').slideUp();
    await this.setSalesChannel(data?.IdPoliticaComercial);
    if (!window.vtexjs?.checkout?.orderForm?.shippingData) {
      await this.setPostalCodeOncheckout(data?.postalCode);
    }
    if (this.callbacksAfterOkBeforeReload.length) {
      await Promise.all(
        this.callbacksAfterOkBeforeReload.map(async (cb) => {
          try {
            await cb();
          } catch (e) {
            console.error(e);
          }
        }),
      );
    }
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  cleanStorageEnv() {
    window.localStorage.removeItem('postalcode-data');
    window.localStorage.removeItem('postalcode-allowed');
  }

  async fixSalesChannelByUrl() {
    const scInUrl = new URL(window.location.href)?.searchParams.get('sc');
    const scInLocalStorage = this.getUserPostalCodeData()?.IdPoliticaComercial;

    // existe na URL, então precisamos atualizar o SC
    if (scInUrl) {
      const resultScSet = await this.setSalesChannel(scInUrl);
      if (!resultScSet.status) {
        this.cleanStorageEnv();
        window.location.reload();
      } else {
        // se for diferente do que já tinha no localstorage, precisamos limpar, pois resetou o cookie
        if (scInLocalStorage !== scInUrl) {
          this.cleanStorageEnv();
        }
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('sc');
        window.location.href = newUrl.href;
      }
      return;
    }
  }

  async fixSalesChannel() {
    await this.fixSalesChannelByUrl();

    let data = {} as PostalCodeResultFromMasterdata;
    try {
      data = JSON.parse(window.localStorage.getItem('postalcode-data'));
    } catch (e) {
      console.error(e);
    }

    // pegar valor que está no cookie (pois na URL já foi ajustado em fixSalesChannelByUrl)
    const sc = this.getSalesChannel();

    // se usuário tem postalCode preenchido, significa que ele preencheu em alguma vez o input de CEP
    if (this.userWasPostalCode()) {
      const userPostalCode = this.getUserPostalCode();
      // se ele prencheu o postalCode, então pode ser que ele tenha colocado um CEP não atendido.
      const postalCodeAllowed = window.localStorage.getItem('postalcode-allowed');
      if (postalCodeAllowed === '0') {
        // nada fazer, o cep dele não é atendido, e já foi tratado os dados.
        this.setHeaderLocationInfo({
          postalCode: `${userPostalCode}`,
        });
      } else {
        // se é atendido, vamos verificar se ele tem dados basicos
        if (data?.IdPoliticaComercial) {
          // se tem, então precisamos só comparar se é igual ao do Cookie
          if (sc === data?.IdPoliticaComercial) {
            // se for igual, nada fazer
            this.setHeaderLocationInfo({
              locationName: data?.NomePoliticaComercial,
              postalCode: `${userPostalCode}`,
            });
          } else {
            // se for diferente, precisamos forçar update do cookie
            await this.setSalesChannel(data?.IdPoliticaComercial);
            // forçamos reload
            const newUrl = new URL(window.location.href);
            if (!!newUrl.searchParams.get('sc')) {
              newUrl.searchParams.delete('sc');
            }
            window.location.href = newUrl.href;
            return;
          }
        } else {
          // se não tem politica comercial no masterdata, então precisamos pesquisar no masterdata pelo CEP do cliente
          const inMasterData = await this.serchPostalCodeInMasterdata(userPostalCode);
          // se encontramos dados...
          if (inMasterData?.IdPoliticaComercial) {
            // garante que salvou os dados no localstorage
            this.prepareEnvForAllowedPostalCode(inMasterData); // essa função já força reload
          } else {
            // se não encontrou nada no masterdata, mas estava marcado como liberado para venda, precisamos resetar os dados de liberação
            this.prepareEnvForNotAllowedPostalCode({
              postalCode: userPostalCode,
            });
          }
        }
      }
    } else {
      // se ele não tem postalCode, então precisamos tratar e validar se tem dados basicos
      if (sc) {
        const inMasterData = await this.serchPostalCodeInMasterdataBySc(sc);
        if (inMasterData?.IdPoliticaComercial) {
          if (inMasterData?.IdPoliticaComercial !== sc) {
            this.prepareEnvForAllowedPostalCode({
              // and reload
              ...inMasterData,
            });
          }

          this.setHeaderLocationInfo();
        } else {
          // se não tem dados basicos, então precisamos resetar o cookie
          this.cleanStorageEnv();
          await this.setDefaultSalesChannel();
        }
      }
    }
  }

  async validateBodyClass() {
    const postalCodeAllowed = window.localStorage.getItem('postalcode-allowed');
    if (postalCodeAllowed === '0') {
      document.body.classList.add('postalCodeAllowed-0');
      return;
    }
    document.body.classList.add('postalCodeAllowed-1');
  }

  async setDefaultSalesChannel() {
    const sc = this.getSalesChannel();
    await this.setSalesChannel(this.defaultSalesChannel);

    // se antes era vazio, e agora é 1
    if (!(sc === '' && this.getSalesChannel() === '1')) {
      window.location.reload();
      return;
    }
    // this.validateBodyClass();
  }

  setHeaderLocationInfo(props?: { locationName?: string; postalCode?: string }) {
    const postalCodeAllowed = window.localStorage.getItem('postalcode-allowed');
    const { locationName, postalCode } = props || {};
    let locationNameText = '';

    if (locationName) {
      locationNameText = `<b>${locationName}</b>`;
      if (postalCode) {
        locationNameText += ` - <span class="d-md-inline d-none">CEP</span> <b>${this.formatPostalCode(
          postalCode,
        )}</b>`;
      }
    } else {
      if (postalCode) {
        locationNameText += ` <span class="d-md-inline d-none">CEP</span> <b>${this.formatPostalCode(postalCode)}</b>`;
      } else {
        if (postalCodeAllowed === null) {
          switch (this.getSalesChannel()) {
            case '1':
              locationNameText = '<b>São Paulo - SP</b>';
              break;
            case '3':
              locationNameText = '<b>Brasília</b>';
              break;
            case '4':
              locationNameText = '<b>Rio de Janeiro - RJ</b>';
              break;
            case '5':
              locationNameText = '<b>Goiás</b>';
              break;
            default:
              locationNameText = '<b>Informe seu CEP</b>';
              $('#localization-string').siblings('.msg-warning-cep').remove();
          }
        }
      }
    }

    if (postalCodeAllowed === '0') {
      $('#localization-string')
        .html(
          `Ops! Ainda não atendemos a sua região ${locationNameText}. Mas você pode continuar no site para conhecer os produtos Swift. :)`,
        )
        .siblings('.msg-warning-cep')
        .remove();
      return;
    }
    $('#localization-string').html(
      `<span class="d-none msg-warning-cep">Apresentando produtos disponíveis para </span> ${locationNameText}.`,
    );
  }
  clearLocalStorageSearch(key) {
    var arr = [];
    for (var i = 0; i < localStorage.length; i++) {
      if (localStorage.key(i).substring(0, 20) == key.substring(0, 20)) {
        arr.push(localStorage.key(i));
      }
    }
    for (var i = 0; i < arr.length; i++) {
      localStorage.removeItem(arr[i]);
    }
  }

  async triggers() {
    new window.storeTheme.helpers.inputMask(this.$postalCodeInput[0]);
    this.$postalCodeForm.on('submit', this.handlePostalcodeFormSubmit.bind(this));
    this.$postalCodeInput.on(
      'keypress keyup focus paste input propertychange change',
      this.onChangeInputPostalCode.bind(this),
    );
    this.$btnUseGeoLocation.on('click', this.requestGeoLocation.bind(this));

    const stateData = {} as StateType;
    this.state = new Proxy(stateData, {
      set: (obj, prop, value) => {
        if ('searchingPostalcode' === prop) {
          if (value === true) {
            this.showLoader();
            this.clearLocalStorageSearch('swift-search-result1--');
          } else {
            this.hideLoader();
          }
        }
        obj[prop] = value;
        return true;
      },
      get: function (target, name) {
        return name in target ? target[name] : undefined;
      },
    });

    this.$widget.find('.close').on('click', () => {
      this.state.searchingPostalcode = false;
    });

    this.validateBodyClass();
  }

  async onChangeInputPostalCode(event) {
    const code = event.currentTarget.value.replace(/\D/g, '');

    if (code.length === 8) {
      this.state.postalCodeIsValid = true;
      return;
    }
    this.state.postalCodeIsValid = false;
  }

  /**
   * Retorna o número do canal de venda atual configurado na loja
   * @returns number
   */
  getSalesChannel(): string {
    // @ts-ignore
    return ((document.cookie.match(/^(.*)sc=(?<sc>[^;]+)(.*)$/) || {}).groups || {}).sc || '1';
  }

  /**
   * Seta o canal de venda na loja e realiza processos necessários para aplicação da informação
   *
   * @param salesChannel string
   */
  async setSalesChannel(salesChannel: string): Promise<{ status: boolean; error?: any }> {
    const sc = this.getSalesChannel();

    // previnir que realize atualização sem necessidade
    if (sc === salesChannel) {
      return {
        status: true,
      };
    }

    try {
      await fetch(`/Site/Track.aspx?referrer=&sc=${salesChannel}`);
      return {
        status: true,
      };
    } catch (e) {
      return {
        status: false,
        error: e,
      };
    }
  }

  /**
   * Pesquisa no masterdata a configuração de canal de venda para o CEP informado
   * @param postalCode string CEP
   */
  async serchPostalCodeInMasterdata(postalCode: string): Promise<PostalCodeResultFromMasterdata> {
    this.state.searchingPostalcode = true;
    const response = await this.masterdataCP.get({
      fields: 'CepFinal,IdPoliticaComercial,CepInicial,NomePoliticaComercial',
      where: `(((CepInicial<${postalCode}) AND (CepFinal>${postalCode})) OR (CepInicial=${postalCode}) OR  (CepFinal=${postalCode}))`,
    });
    this.state.searchingPostalcode = false;
    return (response || [])?.[0];
  }

  async serchPostalCodeInMasterdataBySc(sc: string): Promise<PostalCodeResultFromMasterdata> {
    this.state.searchingPostalcode = true;
    const response = await this.masterdataCP.get({
      fields: 'CepFinal,IdPoliticaComercial,CepInicial,NomePoliticaComercial',
      where: `(IdPoliticaComercial=${sc})`,
    });
    this.state.searchingPostalcode = false;
    return (response || [])?.[0];
  }

  async loadMapsApi() {
    return new Promise((resolve) => {
      const apiKey = 'AIzaSyCbmqGP8f83mUPXFScC6r5zvyA0CS5eQcU';
      if ($('script[src*="https://maps.google.com/maps/api/"]').length) {
        resolve(true);
        return;
      }
      const url = `https://maps.google.com/maps/api/js?libraries=&key=${apiKey}&callback=SalesChannelSelectorCallbackMapsApi`;
      window.SalesChannelSelectorCallbackMapsApi = () => {
        resolve(true);
        // $(window).trigger('maps.google.com.ready');
      };
      (function (d) {
        var s = d.createElement('script');
        s.setAttribute('src', url);
        (d.body || d.head).appendChild(s);
      })(document);
    });
  }

  /**
   * Realizar a solicitação do usuário para autorizar acesso a geoloalização
   */
  async requestGeoLocation() {
    this.state.searchingPostalcode = true;

    const displayLocationInfo = async (position) => {
      const geocoder = new window.google.maps.Geocoder();
      const latlng = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };

      this.userAlowSharePosition = true;
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK' && results?.length) {
          const address = results?.find((item) => {
            return item.types.includes('postal_code');
          });
          let postalCode =
            address?.address_components?.find((item) => {
              return item.types.includes('postal_code');
            })?.long_name || '';

          if (postalCode.length === 5) {
            postalCode = `${postalCode}000`;
          }

          if (postalCode) {
            this.$postalCodeInput.val(postalCode).trigger('change');
            setTimeout(() => {
              this.$postalCodeForm.trigger('submit');
            }, 10);
            return;
          }
        }
        console.warn('🥩 Geocode result: ', results, status);
        this.$messageResult.html(
          '<strong>Ops...<br /><span class="font-weight-normal">Não conseguimos encontrar o endereço para a localização do seu navegador.<br />Por favor, informe seu CEP.</span></strong>',
        );
        this.state.searchingPostalcode = false;
        this.$postalCodeInput.focus();
      });
    };

    const handleLocationError = (error) => {
      this.state.searchingPostalcode = false;

      switch (error.code) {
        case 3:
          // timeout was hit, meaning nothing's in the cache
          // let's provide a default location:
          // displayLocationInfo({
          //   coords: { longitude: latInicial, latitude: longInicial },
          // });

          // now let's make a non-cached request to get the actual position
          // navigator.geolocation.getCurrentPosition(displayLocationInfo, handleLocationError);
          this.$messageResult.html(
            '<strong>Ops...<br /><span class="font-weight-normal">Não foi possível utilizar sua localização.<br />Por favor, informe seu CEP.</span></strong>',
          );
          break;
        case 2:
          console.warn("🥩 [navigator.geolocation] ...device can't get data");
          this.$messageResult.html(
            '<strong>Ops...<br /><span class="font-weight-normal">Não foi possível encontrar sua localização automática.<br />Por favor, informe seu CEP.</span></strong>',
          );
          break;
        case 1:
          console.warn('🥩 [navigator.geolocation] ...user said no');
          this.$messageResult.html(
            '<strong>Ops...<br /><span class="font-weight-normal">Seu navegador não está com a localização habilitada.<br />Por favor, informe seu CEP.</span></strong>',
          );
          break;
        default:
          this.$messageResult.html(
            '<strong>Ops...<br /><span class="font-weight-normal">Não foi possível utilizar sua localização automática.<br />Por favor, informe seu CEP.</span></strong>',
          );
          console.warn('🥩 [navigator.geolocation] ...', error);
          break;
      }
    };

    await this.loadMapsApi();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(displayLocationInfo, handleLocationError, {
        enableHighAccuracy: true,
        maximumAge: 1500000,
        timeout: 10000,
      });
    }
  }

  getPostalCodeByGeoLocation() {}
}

window.storeTheme = window.storeTheme || ({} as StoreTheme);

Object.assign(window.storeTheme, {
  salesChannelSelector: new SalesChannelSelector(),
});

export default SalesChannelSelector;
